var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "devicon:twitter",
    clipPath: "url(#clip0_1019_4674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.0165 30.1484L67.5151 0.507812H61.4721L39.3324 26.2438L21.6487 0.507812H1.25244L27.9935 39.4256L1.25244 70.5078H7.29541L30.6765 43.3298L49.3512 70.5078H69.7474L42.0149 30.1484H42.0165ZM33.7401 39.768L31.0303 35.8928L9.47252 5.05672H18.7541L36.1507 29.9428L38.8599 33.818L61.4749 66.1656H52.1944L33.7401 39.7696V39.768Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1019_4674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5 0.507812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.6e2ef858b8b1fa83b3cc771bc565600a.svg";
export { ForwardRef as ReactComponent };